import type { Module } from 'vuex';
import { LanguagePageItem } from '@/types/LanguagePageItem';
import {RootState} from "@/store";

export interface LanguagePageItemState {
  languagePageItem: LanguagePageItem | null;
  deleted: boolean;
}

const languagePageItemModule: Module<LanguagePageItemState, RootState> = {
  namespaced: true,

  state: (): LanguagePageItemState => ({
    languagePageItem: null,
    deleted: false,
  }),

  mutations: {
    setLanguagePageItem(state, payload: any) {
      if (payload === null || payload === undefined) {
        state.languagePageItem = null;
        state.deleted = false;
        return;
      }
      state.languagePageItem = LanguagePageItem.fromRaw(payload);
      state.deleted = false;
    },

    setLanguagePageItemDelete(state, payload: { idLanguagePageItem: number }) {
      if (state.languagePageItem?.idLanguagePageItem === payload.idLanguagePageItem) {
        state.deleted = true;
      }
    },

    clearLanguagePageItem(state) {
      state.languagePageItem = null;
      state.deleted = false;
    },
  },

  actions: {
    wsSetLanguagePageItem({ commit }, payload) {
      commit('setLanguagePageItem', payload);
    },

    wsSetEmptyLanguagePageItem({ commit }) {
      commit('setLanguagePageItem', null);
    },

    wsLanguagePageItemDelete({ commit }, payload) {
      commit('setLanguagePageItemDelete', payload);
    },

    clearLanguagePageItem({ commit }) {
      commit('clearLanguagePageItem');
    },
  },
};

export default languagePageItemModule;
